import DOMPurify from "dompurify";

// Allow the tags/attrs TipTap actually produces + common inline formatting.
// Explicitly forbid scripts, event handlers, iframes, and dangerous URI schemes.
const CONFIG = {
    ALLOWED_TAGS: [
        "p", "br", "strong", "em", "u", "s", "b", "i",
        "h1", "h2", "h3", "h4",
        "ul", "ol", "li",
        "blockquote", "code", "pre",
        "a", "span",
    ],
    ALLOWED_ATTR: ["href", "target", "rel", "class", "data-ai-insert", "data-proofread"],
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ["script", "iframe", "object", "embed", "style"],
    FORBID_ATTR: ["style", "onerror", "onload", "onclick", "onmouseover"],
};

export function sanitizeHtml(html) {
    if (!html || typeof html !== "string") return "";
    return DOMPurify.sanitize(html, CONFIG);
}
